import { createAction, props } from '@ngrx/store';

export const changeStartYearMonth = createAction('[Span] change start', props<{ year: number; month: number }>());
export const changeEndYearMonth = createAction('[Span] change end', props<{ year: number; month: number }>());
